const getEnvConfig = () => {
  // eslint-disable-next-line no-underscore-dangle
  return window._env_;
};

export { getEnvConfig };
